import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import PermissionsList from '../../components/Admin/PermissionsList';

const PermissionsListPage = () => (
  <PageWrapper>
    <PermissionsList />
  </PageWrapper>
);

export default PermissionsListPage;

